
import { Component, Vue, Prop } from "vue-property-decorator";
import { reduce, sortBy } from "lodash";
import { LeaderBoard } from "@/models/LeaderBoard";
import { LeaderBoardTeams } from "@/models/LeaderBoardTeams";
import { Duration } from "luxon";

@Component
class Overview extends Vue {
  @Prop({ default: "" }) readonly leaderBoardArray!: LeaderBoard[];
  gameWithRatioKey = {} as LeaderBoard;
  gameWithRatioKeyTitle = "";

  get totalGames(): number {
    return this.leaderBoardArray.length;
  }

  get teamsInPlay(): number {
    let total = 0;
    this.leaderBoardArray.forEach((value) => {
      if (value.team_stats !== undefined) {
        total += Object.keys(value.team_stats).length;
      }
    });
    return total;
  }

  get getGameWithMostTeams(): string {
    let total = 0;
    let adminName = "";
    this.leaderBoardArray.forEach((value) => {
      let count = 0;
      for (const k in value.team_stats) {
        count += Object.keys(value.team_stats[k].members).length;
      }
      if (total < count) {
        total = count;
        adminName = value.meta.admin_name;
        this.gameWithRatioKey = value;
        this.gameWithRatioKeyTitle = value.meta.admin_name;
      }
    });
    return total + " [" + adminName + "]";
  }

  get totalNumberOfPlayers(): number {
    let total = 0;
    this.leaderBoardArray.forEach((value) => {
      for (const k in value.team_stats) {
        total += Object.keys(value.team_stats[k].members).length;
      }
    });
    return total;
  }
  get getAveragePlayersPerGame(): string {
    return (this.totalNumberOfPlayers / this.teamsInPlay).toFixed(2);
  }

  get teamSuccessPercentage(): string {
    var highestRatio = 0;
    var cityName = "";
    this.leaderBoardArray.forEach((value: LeaderBoard) => {
      if (value.team_stats !== undefined) {
        const successPer =
          (reduce(
            value.team_stats,
            (memo: number, leader: LeaderBoardTeams) => {
              if (leader.game_status === "win") {
                return memo + 1;
              }
              return memo;
            },
            0
          ) /
            Object.keys(value.team_stats).length) *
          100;

        if (successPer > highestRatio) {
          highestRatio = successPer;
          cityName = value.meta.city_dname.en;
        }
      }
    });
    return highestRatio.toFixed(2) + "% | " + "[" + cityName + "]";
  }

  get getFastestVerified(): string {
    let fastest = Number.MAX_VALUE;
    let cityName = "";
    let teamName = "";
    this.leaderBoardArray.forEach((value) => {
      if (value.team_stats !== undefined) {
        const results = sortBy(value.team_stats, "timer.comp_dur_s");
        const time = results[0].timer?.comp_dur_s;
        if (time !== undefined || time === null) {
          if (time < fastest) {
            fastest = time;
            cityName = value.meta.city_dname.en;
            teamName = results[0].team_dname;
          }
        }
      }
    });
    if (fastest == Number.MAX_VALUE) {
      return "N/A";
    }
    return (
      Duration.fromObject({ seconds: fastest }).toFormat("hh:mm:ss") +
      " | [" +
      cityName +
      " & " +
      teamName +
      "]"
    );
  }

  openLeaderBoard(leaderBoard: LeaderBoard, leaderBoardTitle: string): void {
    const value = {
      leaderBoard: leaderBoard,
      leaderBoardTitle: leaderBoardTitle,
    };
    this.$emit("openLeaderBoard", value);
  }
}

export default Overview;
